<script>
    import _                    from 'lodash'
    import { navigate }         from "svelte-routing"
    import * as api             from '../../shared/api.js'
    import { company, domains } from '../../shared/stores.js'
    import AppLoader            from '../../shared/Loader.svelte'
    import SectionTitle         from '../../shared/SectionTitle.svelte'
    import DomainDropdown       from '../../shared/DomainDropdown.svelte'
    import ProfileItem          from './ProfileItem.svelte'
    
    export let _domain  = false
    export let _company = false

    let buffer    = []
    let active    = -1
    let domain    = null
    let loading   = false
    let error     = false
    let deflt     = false
    let archetype = empty()

    if(_domain) {
        domain = $domains.find(it => it.domain === _domain)
    }

    function onDomainSelected(selected) {
        domain = selected ? selected.value : null
        if(domain) {
            navigate(`/empresa/${$company.id}/perfis/${domain.domain}`)
        } else {
            navigate(`/empresa/${$company.id}/perfis`)
        }
    }

    function empty() {
        return { 
            id: 0, 
            name: null,
            description: null,
            constraints: []
        }
    }

    function updateBuffer(evt) {
        const add     = evt.detail.add
        const payload = evt.detail.payload
        const remove  = evt.detail.remove
        if(remove) {
            buffer = buffer.filter(it => it.id !== remove)
        }
        if(add) {
            archetype = empty()
            buffer = [...buffer, payload]
        }
    }

    function loadBuffer(domain) {
        if(!domain) {
            buffer = []
            return 
        } 

        loading = true
        return api.get(`/profiles/domain/${domain.id}`)
            .then(api.toJsonIf200)
            .then(json => {
                buffer  = json
                loading = false
                error   = false
            })
            .catch(err => {
                loading = false
                error   = err
            })        
    }
    
    $: loadBuffer(domain)

</script>
<svelte:head>
    <title>Dogma / {$company.name} / Perfis</title>
</svelte:head>

{#if loading || error}
    <AppLoader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Perfis de Titulares
    </SectionTitle>

    <DomainDropdown {domain} {onDomainSelected} />

    {#if !domain}
        <div class="ui big message">
            Selecione um domínio
        </div>
    {:else}
        <div class="ui raised segments">
            <div class="ui segment">
                <div class="places">
                    <h2 class="ui header">Perfis</h2>
                </div>
            </div>
            {#if buffer.length === 0}
                <div class="ui segment">
                    <div class="ui big message">
                        Não existem perfis cadastrados ainda
                    </div>
                </div>
            {/if}

            <ProfileItem 
                {domain} 
                item={archetype} 
                bind:active 
                on:message={updateBuffer}>
            </ProfileItem>
            {#each buffer as item (item.id)}
                <ProfileItem 
                    {domain} 
                    bind:item 
                    bind:active 
                    on:message={updateBuffer}>
                </ProfileItem>
            {/each}
        </div>
    {/if}
{/if}
